import { Component, HostListener, OnInit, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { Router } from '@angular/router';
import { QuotationService } from '../../features/quotation/services/quotation.service';
import { PaginationHelper } from '../../shared/services/pagination.service';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import * as selectPermissions from '../../core/permissions/permission.selector';
// import { Permission } from '../../shared/services/permissions';
// import { Store } from '@ngrx/store';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';

@Component({
  selector: 'app-quotation',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatInputModule,
    AgGridAngular,
    // PermissionDirective,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule
  ],
  templateUrl: './quotation.component.html',
  styleUrl: './quotation.component.scss',
})
export class QuotationComponent implements OnInit {
  public viewPortSize: boolean = false;
  public rowData: any[] = [];
  public loading: boolean = true;
  public summaryLoading: boolean = true;
  public error: any = null;
  quotesDashboardData: any;
  private searchSubject = new Subject<string>();
  profileName: any;
  private userData: any[];
  private parentQuoteStatus:string;
  projectId: number;
  startDate: any;
  endDate: any;
  dateRangeForm: FormGroup;
  page = 0;
  pageSize = 10;
  totalPages = 1;
  pageSizeOptions = [5, 10, 20, 50, 100];
  search: any;

  dateFilter = (date: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Remove time component
    return date ? date <= today : false;
  };


  columnDefs: (
    | {
      headerName: string;
      field: string;
      flex: number;
      cellRenderer?: undefined;
      floatingFilter?: undefined;
      filter?: undefined;
    }
    | {
      field: string;
      headerName: string;
      flex: number;
      cellRenderer: (params: any) => HTMLDivElement;
      floatingFilter: boolean;
      filter: boolean;
    }
  )[];
  // profileName: any;
  // Permission = Permission;
  canCreateQuotation$ = this.permissionService.hasPermission(
    ModuleIds.Quotation,
    'Create'
  );
canEditQuotation$ = this.permissionService.hasPermission(
    ModuleIds.Quotation,
    'Edit'
  );
  canDeleteQuotation$ = this.permissionService.hasPermission(
    ModuleIds.Quotation,
    'Delete'
  );
  canDeleteQuotation: boolean = false;
  canEditQuotation: boolean = false;

  constructor(
    private router: Router,
    private quotationService: QuotationService,
    private datePipe: DatePipe,
    private quoteService: QuotationService,
    private toastr: ToastrService,
    // private store: Store,
    private fb: FormBuilder,
    private permissionService: PermissionService
  ) {
    const loggedInUser: any = localStorage.getItem('loggedInUser');
    const userData = JSON.parse(loggedInUser);
    this.userData = userData;
    this.profileName = userData?.profileData?.profileName;
    console.log("Profile Name:", this.profileName);
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  readonly dialog = inject(MatDialog);

  openDialog() {
    const dialogRef = this.dialog.open(UploadQuotationDialog);
  }

  isDropdownOpen = false;

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {
    this.columnDefs = [
      {
        headerName: 'Code',
        field: 'quoteCode',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Date',
        field: 'quoteDate',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Project Name',
        field: 'projectName',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Customer Name',
        field: 'customerName',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Total Amount',
        field: 'totalAmount',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Status',
        field: 'quoteStatus',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        field: 'action',
        headerName: 'Actions',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.gap = '20px';

          const editIcon = document.createElement('img');
          editIcon.src = 'assets/images/icons/icon-edit.svg';
          editIcon.style.cursor = 'pointer';
          editIcon.setAttribute('data-action', 'edit');

          const deleteIcon = document.createElement('img');
          deleteIcon.src = 'assets/images/icons/icon-delete.svg';
          deleteIcon.style.cursor = 'pointer';
          deleteIcon.setAttribute('data-action', 'delete');
          deleteIcon.setAttribute('title', 'Delete');
          // container.appendChild(editIcon);

          if((params.data?.quoteStatus === 'Draft' || params.data?.quoteStatus === 'Pending')&&this.canEditQuotation){
            container.appendChild(editIcon);
          }
          if(params.data?.quoteStatus === 'Draft'&&this.canDeleteQuotation){
            container.appendChild(deleteIcon);
          }
          

          // console.log("params.data:", params.data)

          // this.store
          //   .select(selectPermissions.hasPermission('5', Permission.Delete))
          //   .subscribe((canDelete) => {
          //     if (canDelete) {
          //       container.appendChild(deleteIcon);
          //     }
            // });

          // if (this.profileName === 'admin' && params?.data?.parentQuoteStatus === 'Confirmed') {
          //   if (params?.data?.isEditable === true) {
          //     const enableIcon = document.createElement('img');
          //     enableIcon.src = 'assets/images/icons/icon-enable.svg';
          //     enableIcon.style.cursor = 'pointer';
          //     enableIcon.setAttribute('data-action', 'enable');
          //     enableIcon.setAttribute('title', 'Enabled');
          //     container.appendChild(enableIcon);
          //   } else if (params?.data?.isEditable === false) {
          //     const disableIcon = document.createElement('img');
          //     disableIcon.src = 'assets/images/icons/icon-disable.svg';
          //     disableIcon.style.cursor = 'pointer';
          //     disableIcon.setAttribute('data-action', 'disable');
          //     disableIcon.setAttribute('title', 'Disabled');
          //     container.appendChild(disableIcon);
          //   }
          // }

          return container;
        },
        floatingFilter: false,
        filter: false,
      },
    ];
  }

  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10];
  public themeClass: string = 'ag-theme-quartz';

  ngOnInit(): void {
    const navigation = history.state;
    this.projectId = navigation.projectID || null;  // Retrieve projectID
    console.log('Project ID:', this.projectId);
    this.fetchQuotations();
    this.fetchQUoteSummary();

    this.dateRangeForm = this.fb.group({
      startDate: [''],
      endDate: ['']
    });
    
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.search=searchTerm
        this.fetchQuotations();
      });

    this.checkViewportSize();
    this.canDeleteQuotation$.subscribe(val => {
      this.canDeleteQuotation = val;
    });
    this.canEditQuotation$.subscribe(val => {
      this.canEditQuotation = val;
    });
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    this.pageSize = 10;
    this.page = 0;
    this.searchSubject.next(input.value);
  }

  clearFilter(){
    this.dateRangeForm.reset();
    this.startDate = null;
    this.endDate = null;
    this.fetchQuotations();
    this.fetchQUoteSummary();
  }

  private fetchQUoteSummary() {
    this.summaryLoading = true;
    this.quotationService.fetchQuoteSummary(this.startDate, this.endDate).subscribe({
      next: (summary) => {
        this.quotesDashboardData = summary;
      },
    });
  }

  fetchQuotations(pageSize: number = 10
  ) {
    this.loading = true;
    if (pageSize) {
      this.pageSize = pageSize;
    }
    const filter = {
      quoteStatus : this.parentQuoteStatus
    }
    const skip = this.page * this.pageSize;
    const input = {
      search: this.search,
      limit: this.pageSize,
      filter,
      // advancedSearch: this.advancedSearch,
      startDate:this.startDate,
      endDate: this.endDate,
      skip,
    }
    this.quotationService
      .findAllQuotessWithPagination(input)
      .subscribe({
        next: (quotes) => {
          this.totalPages = Math.ceil(
            (quotes?.total || quotes?.quotes?.length) / this.pageSize
          );    
          this.rowData = (quotes?.quotes || []).map((quote: any) => {
            return {
              id: quote?.id,
              parentCode: quote?.parentCode || '--',
              quoteDate: this.datePipe.transform(
                quote?.quoteDate,
                'dd/MM/yyyy'
              ) || '--',
              quoteCode: quote?.quoteCode || '--',
              customerName: quote?.customerData?.firstName + ' ' + quote?.customerData?.lastName || '--',
              projectName: quote?.projectName || '--',
              // parentQuoteStatus: this.findStatus(quote?.quoteData[0]?.status),
              quoteStatus: quote?.quoteStatus || '--',
              totalAmount: quote?.totalAmount || '--',
              isEditable: quote?.isEditable,
            };
          });

          // Update pagination options based on the rowData length
          // this.paginationPageSizeSelector =
          //   PaginationHelper.getPaginationPageSizeOptions(this.rowData);

          this.loading = false;
        },
        error: (err) => {
          console.error('Error fetching journals:', err);
          this.toastr.error('Failed to fetch quotes');
          this.loading = false;
        },
      });
  }

  nextPage() {
    if (this.page + 1 < this.totalPages) {
      this.page++;
      this.fetchQuotations(this.pageSize);
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.fetchQuotations(this.pageSize);
    }
  }

  onPageSizeChange(event: Event): void {
    const newSize = Number((event.target as HTMLSelectElement).value);
    console.log('New Page Size:', newSize);
    this.pageSize = newSize; // ✅ Correctly update pageSize
    this.page = 0; // ✅ Reset to first page
    this.fetchQuotations(this.pageSize); // ✅ Use new pageSize
  }

  findStatus(status: string) {
    if (status === 'SENT') {
      return 'Open';
    } else if (status === 'ACCEPTED') {
      return 'Confirmed';
    } else {
      return 'Draft';
    }
  }

  fetchParents(status?: any): void {
    console.log('Fetching parents for status:', status);
    this.parentQuoteStatus = status;
    this.fetchQuotations(); // Optionally, pass the status to the service
  }

  openEdit(quoteData: any) {
    const quoteId = quoteData?.id;
    if (quoteId) {
      this.router.navigate([`/quotation/quotation-edit/${quoteId}`]);
    }
  }

  onCellClicked(params: any) {
    const quoteId = params.data?.id;
    if (
      params.column.colId === 'action' &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;
      const id = params.data.id;
      if (action === 'delete') {
        this.onDeleteParentQuote(params?.data);
      } else if (action === 'enable') {
        this.isEditEnableDisable(id, false);
      } else if (action === 'disable') {
        this.isEditEnableDisable(id, true);
      } else if (action === 'edit') {
        this.openEdit(params?.data);
      }
    } else {
      const id = params.data?.id;
      // this.router.navigate([`/quotation/quotation-details/${quoteId}`]);
      this.router.navigate([`quotation/quotation-details`], {
        queryParams: { id: id },
      });
    }
  }

  onDeleteParentQuote(parentQuoteData: any): void {
    if (parentQuoteData?.quoteStatus === 'Approved') {
      this.toastr.warning('This quote is approved and cannot be deleted.');
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialog);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.removeQuote(parentQuoteData?.id);
      }
    });
  }

  private removeQuote(parentQuoteId: number): void {
    this.quoteService.removeQuote(parentQuoteId).subscribe({
      next: () => {
        this.toastr.success('Quotation removed successfully.');
        this.fetchQuotations();
      },
      error: (error) => {
        this.toastr.error('Failed to remove Quotation. Please try again.');
      },
    });
  }

  onDateChange(event: any, type: string) {
    const formattedDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
    if (type === 'start') {
      this.startDate = formattedDate;
    } else if (type === 'end') {
      this.endDate = formattedDate;
    }
    if (this.startDate != null && this.endDate != null) {
      // this.filter = { startDate: this.startDate, endDate: this.endDate };
      this.fetchQuotations();
      this.fetchQUoteSummary();
    }
  }

  private isEditEnableDisable(id: number, isEditable: boolean): void {
    this.quoteService.changeIsEditable(id, isEditable).subscribe({
      next: (response) => {
        this.toastr.success('Updated.');
        this.fetchQuotations();
      },
      error: (error) => {
        this.toastr.error(error || 'Somethimg went wrong.');
      }
    })
  }
}

@Component({
  selector: 'upload-quotation-dialog',
  templateUrl: 'upload-quotation-dialog.html',
  styleUrls: ['./quotation.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class UploadQuotationDialog {
  file: any = null;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      console.log('Selected file:', file);
      this.file = file;
    }
  }
}
